import styled from 'styled-components';
import { getSpacing, headerHeight } from 'stylesheet';
var Container = styled.div.withConfig({
  displayName: "TabPanelstyle__Container",
  componentId: "sc-3hnfcn-0"
})(["margin-top:calc(", " + ", ");"], headerHeight, getSpacing(2.5));
export { Container };